import {
    REQUEST_LOGIN,
    LOGIN_OK,
    LOGIN_FAILED,
    LOGOUT,
} from '../actions'

function user(state = {
    isLoggedIn: false,
    isLoggingIn: false,
    user: undefined,
    loginFailure: undefined
}, action) {
    switch (action.type) {
        case REQUEST_LOGIN:
            return Object.assign({}, state, {
                isLoggedIn: false,
                isLoggingIn: true,
                user: undefined
            });
        case LOGIN_OK:
            return Object.assign({}, state, {
                isLoggedIn: true,
                isLoggingIn: false,
                loginFailure: undefined,
                user: action.user
            });
        case LOGOUT:
            return Object.assign({}, state, {
                isLoggedIn: false,
                isLoggingIn: false,
                loginFailure: undefined,
                user: undefined
            });
        case LOGIN_FAILED:
            return Object.assign({}, state, {
                isLoggingIn: false,
                isLoggedIn: false,
                loginFailure: action.loginFailure,
                user: undefined,
            });
        default:
            return state
    }
}

export default user


// WEBPACK FOOTER //
// ./src/reducers/user.js